import "./Explore.scss";
import { Fragment, useState, useEffect } from "react";
import ExploreCard from "./explorecard/ExploreCard";

import axios from "axios";
import { baseUrl, getVendors } from "../../../utils/apiData";
import SmallLoader from "../../../components/smallLoader/SmallLoader";

const Explore = ({ title, categoryId }) => {
  const [loader, setLoader] = useState(false);
  const [dataList, setDataList] = useState([]);

  const getVendorApi = async () => {
    setLoader(true);
    try {
      const res = await axios.post(`${baseUrl}/${getVendors}`, {
        categoryId: categoryId,
      });
      if (res?.data?.success) {      
        setDataList(res?.data?.data);
        setLoader(false);
      }
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  useEffect(() => {
    getVendorApi();
  }, []);

  return (
    <section className="explore_sec" id={`sec${categoryId}`}>
      <div className="content_wrap p_bottom ">
        <div className="title">
          <h2 className="wow fadeInUp">{title}</h2>
        </div>
        {loader ? (
          <SmallLoader />
        ) : dataList?.length > 0 ? (
          <div className="explore_grid">
            {dataList?.map((data, j) => {
              return (
                <Fragment key={data._id}>
                  <ExploreCard data={data} j={j} />
                </Fragment>
              );
            })}
          </div>
        ) : (
          <p className="text-center">Data not found...</p>
        )}
      </div>
    </section>
  );
};

export default Explore;
